import { validateInputs } from 'shared/lib';
import { SignUpBusinessErrorsEnum } from 'shared/consts/sign-up-business.error';

interface IValidateForm {
  name: string;
  address: string;
  phone: string;
  siteUrl: string;
  description: string;
}

export const validateForm = ({
  name,
  address,
  phone,
  siteUrl,
  description,
}: IValidateForm) => {
  if (!validateInputs.validateBusinessName(name)) {
    return SignUpBusinessErrorsEnum.INCORRECT_NAME;
  }
  if (!validateInputs.validateBusinessAddress(address)) {
    return SignUpBusinessErrorsEnum.INCORRECT_ADDRESS;
  }
  if (!validateInputs.validatePhone(phone)) {
    return SignUpBusinessErrorsEnum.INCORRECT_PHONE;
  }
  if (!validateInputs.validateLink(siteUrl)) {
    return SignUpBusinessErrorsEnum.INCORRECT_LINK;
  }
  if (!validateInputs.validateDescription(description)) {
    return SignUpBusinessErrorsEnum.INCORRECT_DESCRIPTION;
  }
};
